<script lang="ts">
import SectionLieu from '@/generated/sections/SectionLieu.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionLieu
})

</script>
